import { INPUT_TEXT_MAX_LENGTH } from '@/common/constants';
import yup from '@/plugins/yup';
import { ElLoading } from 'element-plus';
import { useField, useForm } from 'vee-validate';
import { projectPlanningService } from '../services/planning.service';
import { IPath3D } from '../interfaces';
import {
    showErrorNotificationFunction,
    showSuccessNotificationFunction,
} from '@/common/helpers';
import { useI18n } from 'vue-i18n';
import { projectPlanningModule } from '../store';

const DEFAULT_PATH_COLOR = '#C00000';

const path3DFormSchema = yup.object({
    name: yup.string().trim().max(INPUT_TEXT_MAX_LENGTH).required(),
    color: yup
        .string()
        .transform((value) => (value === null ? undefined : value))
        .matches(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)
        .required(),
    isDisplay: yup.boolean(),
    nodeName: yup.string().optional(),
});

export const innitPath3DForm = {
    name: '',
    color: DEFAULT_PATH_COLOR,
    isDisplay: true,
    nodeName: '',
};

export const setupPath3DForm = () => {
    const { t } = useI18n();

    const { errors, meta, handleSubmit, resetForm, setFieldValue, validate } = useForm({
        initialValues: innitPath3DForm,
        validationSchema: path3DFormSchema,
    });

    const onSubmit = async (selectedPath3D?: IPath3D | null) => {
        return await handleSubmit(async (values) => {
            let response;

            const payload = {
                name: values?.name || '',
                color: values?.color || '',
                isDisplay: !!values?.isDisplay,
            };

            const loading = ElLoading.service({});

            if (selectedPath3D) {
                response = await projectPlanningService.updatePath3D(
                    selectedPath3D?._id || '',
                    payload,
                );
            } else {
                response = await projectPlanningService.createPath3D({
                    ...payload,
                    planningId: projectPlanningModule?.planning?._id || '',
                    nodeName: values?.nodeName || '',
                });
            }

            if (response?.success) {
                showSuccessNotificationFunction(
                    selectedPath3D
                        ? t('planning.path3D.message.updateSuccess')
                        : t('planning.path3D.message.createSuccess'),
                );
            } else {
                showErrorNotificationFunction(
                    response?.message ||
                        (selectedPath3D
                            ? t('planning.path3D.message.updateError')
                            : t('planning.path3D.message.createError')),
                );
            }

            loading.close();

            return response;
        })();
    };

    const { value: name } = useField('name');
    const { value: color } = useField('color');
    const { value: isDisplay } = useField('isDisplay');

    return {
        name,
        color,
        isDisplay,
        errors,
        meta,
        onSubmit,
        resetForm,
        setFieldValue,
        validate,
    };
};
